import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import T from '@prisjakt/ui-translate';

import * as S from './styles';

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated';
import {
  IconHeartFilled,
  IconLikeFilled,
  IconNotificationFilled,
} from '@prisjakt/ui/icon';

type Props = {
  style?: React.CSSProperties;
  className?: string;
};

const YEAR = new Date().getFullYear();

const ShopReviewThankYou = ({ style, className }: Props) => {
  const { market, t, linkTo } = useContext(AppContext);
  const isAuthenticated = useIsAuthenticated();

  return (
    <div style={style} className={className}>
      <S.Title>
        {isAuthenticated
          ? t('reviews', 'store.completed-title')
          : t('reviews', 'store.completed-title-not-logged-in')}
      </S.Title>

      {!isAuthenticated && (
        <>
          <S.Text>
            {t('reviews', 'store.completed-awaiting-verification')}
          </S.Text>
          <S.Text>
            <T domain="reviews">store.verification-email.md</T>
          </S.Text>
        </>
      )}

      {market.shopOfTheYear && (
        <S.Soty>
          <S.Image
            src={`${market.cdn}/g/store_of_the_year/generic_badges/${market.code}/soty_generic.png`}
            alt={t('campaigns', 'shop-of-the-year.title-with-year', {
              year: YEAR,
            })}
            width={100}
          />

          <S.Text>
            <T domain="reviews">store.soty-info.md</T>
          </S.Text>

          <S.Link to={linkTo('shopOfTheYear')}>
            {t('reviews', 'store.completed-soty-link')}
          </S.Link>
        </S.Soty>
      )}

      {isAuthenticated ? (
        <>
          <S.Title>{t('reviews', 'store.completed-profile-title')}</S.Title>

          <S.Text>{t('reviews', 'store.completed-profile-text')}</S.Text>

          <S.Text>
            <IconLikeFilled size={20} color="maybeBlue700" />
            {t('reviews', 'store.completed-profile-helpful')}
          </S.Text>

          <S.Link to="/account/profile">
            {t('reviews', 'store.completed-profile-link')}
          </S.Link>
        </>
      ) : (
        <>
          <S.Title>{t('reviews', 'store.completed-create-account')}</S.Title>

          <S.Text>
            <IconNotificationFilled size={20} color="maybeBlue700" />
            {t('reviews', 'store.completed-alerts')}
          </S.Text>
          <S.Text>
            <IconHeartFilled size={20} color="maybeBlue700" />
            {t('reviews', 'store.completed-lists')}
          </S.Text>
          <S.Text>
            <IconLikeFilled size={20} color="maybeBlue700" />
            {t('reviews', 'store.completed-helpful-profile')}
          </S.Text>

          <S.Link to="/signup">
            {t('account', 'sign-in-promo.create-account-button')}
          </S.Link>
        </>
      )}
    </div>
  );
};

export default ShopReviewThankYou;
